const doc = [({"en":({"js":({"reimbursements":({"documents_button":({"carousel":({"image_current_of_total":"Image %{current} of %{total}"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;